function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17 22.6667C20.1296 22.6667 22.6666 20.1296 22.6666 17C22.6666 13.8704 20.1296 11.3333 17 11.3333C13.8704 11.3333 11.3333 13.8704 11.3333 17C11.3333 20.1296 13.8704 22.6667 17 22.6667Z",
  fill: "#696EF6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.4166 5.76442V2.83334H15.5833V5.76442C13.0904 6.08272 10.7737 7.21958 8.99662 8.99664C7.21956 10.7737 6.0827 13.0904 5.7644 15.5833H2.83331V18.4167H5.7644C6.08223 20.9098 7.21894 23.2267 8.99609 25.0039C10.7732 26.781 13.0902 27.9178 15.5833 28.2356V31.1667H18.4166V28.2356C20.9098 27.918 23.2269 26.7814 25.0041 25.0042C26.7813 23.227 27.918 20.9099 28.2356 18.4167H31.1666V15.5833H28.2356C27.9177 13.0902 26.781 10.7733 25.0039 8.99611C23.2267 7.21896 20.9097 6.08225 18.4166 5.76442ZM17 25.5C12.3122 25.5 8.49998 21.6878 8.49998 17C8.49998 12.3123 12.3122 8.5 17 8.5C21.6877 8.5 25.5 12.3123 25.5 17C25.5 21.6878 21.6877 25.5 17 25.5Z",
  fill: "#696EF6"
});

function SvgCurrentLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLocation);
export default __webpack_public_path__ + "static/media/CurrentLocation.6fc92896.svg";
export { ForwardRef as ReactComponent };